export default __webpack_public_path__ + "static/media/maildeveloper.479f7f66.svg";